import { render, staticRenderFns } from "./already-using.vue?vue&type=template&id=a1fc4be8&scoped=true"
var script = {}
import style0 from "./already-using.vue?vue&type=style&index=0&id=a1fc4be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fc4be8",
  null
  
)

export default component.exports